import React, { useRef, useState, useEffect } from 'react'
import { TablePagination,createStyles,Theme } from '@mui/material'
import useClasses from '../common/useClasses';

interface PaginationProps {
    count: number
    rowsPerPage: number
    page: number
}
type Props = {
    page: number
}

const useStyles = ()=>({
    root: {
        "& div.MuiTablePagination-spacer": {
          fontSize: "0.875rem",
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
          fontWeight: 400,
          lineHeight: 1.43,
          letterSpacing: "0.01071em",
        },
      },
})


let showTotalItem: string
const Pagination: React.FC<PaginationProps> = (props: any) => {
    const ref: any = useRef(null)
    const [page, setPage] = useState(props.page ? props.page : 0)
    const [rowsPerPage, setRowsPerPage] = useState(
        props.rowsPerPage ? props.rowsPerPage : 0,
    )

    const [pageCount, setPageCount] = useState(0)
    var totalPageCount = Math.ceil(props.count / rowsPerPage);

const classes = useClasses(useStyles);

    useEffect(() => {
        const getElement: any = document.querySelector('div.MuiTablePagination-spacer')
        getElement.innerHTML = showTotalItem;
    }, [ref.current, page, rowsPerPage, setPage])


    useEffect(()=>{
        setPageCount(props?.count > 0 ? 1 : 0)
      },[props.count])

    const handleChangePage = (event: any, newPage: number): void => {
        if (newPage > page) {
            setPageCount(pageCount + 1);
        }
        else {
            setPageCount(pageCount - 1);
        }
        setPage(newPage)
        let pageItem = {
            fromCount: (newPage * rowsPerPage) + 1,
            size: rowsPerPage
        }
        props.onChange(pageItem);
       
    }
    
    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>,
    ): void => {
        setRowsPerPage(+parseInt(event.target.value))
        setPage(0);
        setPageCount(1);
        let item = {
            fromCount: (page * (+parseInt(event.target.value))) + 1,
            size: (+parseInt(event.target.value))
        }
        props.onChange(item);
    }
    return (
        <TablePagination
            id='common-pagination'
            ref={ref}
            component="div"
            className={classes.root}
            count={props.count}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={parseInt(rowsPerPage)}
            rowsPerPageOptions={props?.addionalConfig?.rowsPerPageOptions ? props?.addionalConfig?.rowsPerPageOptions : [5, 10, 15, 20, 25, 50, 100]}
            labelDisplayedRows={({ from, to, count }) => {
                showTotalItem = `Showing ${from}-${to} total items ${count}`
                return `Pages ${pageCount} of ${totalPageCount}`
            }}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
    )
}
export default Pagination